export default __webpack_public_path__ + "static/media/31_ShanFong.99cab15d.png";